// app/javascript/controllers/password_toggle_controller.js
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-toggle"
export default class extends Controller {
  static targets = ["passwordField", "toggleIcon"]
  
  connect() {
    console.log("Password toggle controller connected 12345")
  }

  toggleCrtPasswordEmail(event) {
    const passwordField = document.getElementById("ctr-pw-email");
    const icon = document.getElementById("crt-pw-icon-email");
    this.togglePasswordVisibility(passwordField, icon);
  }

  toggleCrtPasswordPassword(event) {
    const passwordField = document.getElementById("crt-pw-pw");
    const icon = document.getElementById("crt-pw-icon-pw");
    this.togglePasswordVisibility(passwordField, icon);
  }

  toggleNewPasswordPassword(event) {
    const passwordField = document.getElementById("new-pw-pw");
    const icon = document.getElementById("new-pw-icon-pw");
    this.togglePasswordVisibility(passwordField, icon);
  }

  toggleConfirmPasswordPassword(event) {
    const passwordField = document.getElementById("conf-pw-pw");
    const icon = document.getElementById("conf-pw-icon-pw");
    this.togglePasswordVisibility(passwordField, icon);
  }

  togglePasswordVisibility(passwordField, icon) {
    if (!passwordField || !icon) return;
    
    if (passwordField.type === "password") {
      icon.classList.remove('bi-eye-slash');
      icon.classList.add('bi-eye');
      passwordField.type = "text";
    } else {
      icon.classList.remove('bi-eye');
      icon.classList.add('bi-eye-slash');
      passwordField.type = "password";
    }
  }
}